import { TrackEvent } from './track';
import {
  getPendingSignup,
  setPendingSignup,
  clearPendingSignup,
} from './signupPending';

/**
 * Whether the courier can verify a customer's phone number (and therefore
 * whether the `sign_up` event should wait for phone verification).
 */
export const isPhoneVerificationAvailable = (
  courierSetting:
    | { isSmsApiEnabled?: boolean; useWaApi?: boolean }
    | undefined
    | null
): boolean => !!(courierSetting?.isSmsApiEnabled || courierSetting?.useWaApi);

/**
 * Called right after email verification + auto-login during signup. If phone
 * verification is available, defer the `sign_up` event until the phone is
 * verified (mark a pending signup); otherwise fire it now — the email-verified
 * point is the furthest completion this courier supports.
 */
export const finalizeSignupAfterEmail = (
  phoneAvailable: boolean,
  userId: string,
  track: TrackEvent
): void => {
  if (phoneAvailable) {
    setPendingSignup(userId);
  } else {
    track('sign_up');
  }
};

/**
 * Called when phone verification succeeds. Fires `sign_up` only if this user has
 * a pending signup (i.e. is mid-signup, not a returning user verifying a phone
 * later), then clears the flag. Returns whether the event fired.
 */
export const trackSignupIfPending = (
  userId: string,
  track: TrackEvent
): boolean => {
  if (getPendingSignup() === userId) {
    track('sign_up');
    clearPendingSignup();
    return true;
  }
  return false;
};
